import { ReportName } from '../../../../../../utils/enums';
import { AllReportsFieldsConfig } from '../../../report-widget-factory/all-top10-columns-config';
import { AggregateCustomerTraffic } from '../../../report-widget-factory/aggregate-customer-traffic-config';
import { NetworkTraffic } from '../../../report-widget-factory/network-traffic/network-traffic';
import GenericReport from './generic-report';
import './report-renderer.scss';
import { kebabCase } from 'lodash';


interface ReportRendererProps {
    reportName: ReportName;
    data: AllReportsFieldsConfig[];
}

const ReportRenderer: React.FC<ReportRendererProps> = ({ reportName, data }) => {

    const renderers: Partial<Record<ReportName, React.FC<{ data: any }>>> = {
        [ReportName.Aggregate_Customer_Traffic]: AggregateCustomerTraffic,
        [ReportName.NETWORK_TRAFFIC]: NetworkTraffic
    };

    const Renderer = renderers[reportName];
    return <div className={`report-data ${kebabCase(reportName)}`}>
        {Renderer ?
            <Renderer data={data}/> :
            <GenericReport data={data} reportName={reportName}/>}
    </div>;
};

export default ReportRenderer;